<script>
import { exactTimestamp } from 'shared/helpers/timeHelper';

export default {
  name: 'TimeAgo',
  props: {
    lastActivityTimestamp: {
      type: [String, Date, Number],
      default: '',
    },
    createdAtTimestamp: {
      type: [String, Date, Number],
      default: '',
    },
    conversationId: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    lastActivityTime() {
      if (!this.lastActivityTimestamp) return '';
      return exactTimestamp(this.lastActivityTimestamp, true);
    },
    createdAtTime() {
      if (!this.createdAtTimestamp) return '';
      return exactTimestamp(this.createdAtTimestamp, true);
    },
    createdAt() {
      if (!this.createdAtTimestamp) return '';
      return `${this.$t('CHAT_LIST.CHAT_TIME_STAMP.CREATED.OLDEST')} ${exactTimestamp(
        this.createdAtTimestamp
      )}`;
    },
    lastActivity() {
      if (!this.lastActivityTimestamp) return '';
      return `${this.$t(
        'CHAT_LIST.CHAT_TIME_STAMP.LAST_ACTIVITY.NOT_ACTIVE'
      )} ${exactTimestamp(this.lastActivityTimestamp)}`;
    },
    tooltipText() {
      return `${this.createdAt}
              ${this.lastActivity}`;
    },
  },
};
</script>

<template>
  <div
    :key="conversationId"
    v-tooltip.top="{
      content: tooltipText,
      delay: { show: 1000, hide: 0 },
    }"
    class="ml-auto leading-4 text-xxs text-n-slate-10 hover:text-n-slate-11 whitespace-nowrap"
  >
    <span>{{ `${createdAtTime} • ` }}</span>
    <span class="font-bold text-xs">{{ lastActivityTime }}</span>
  </div>
</template>
